import {
    counter_RATINGS,
    counter_RATINGS_PHOTOS, STROLLER_ADD_REVIEW,
} from 'mk/autogenerated/translations/StrollerDetailRating.6ff5ec1a538c4ee68fd069a924047886'
import { ACTIVE_SERVER_ID } from 'mk/settings';
import { StrollerEntity, StrollerUserReviewEntity } from 'mk2/apps/strollers/schemas';
import { strollersAddReviewUrl, strollersReviewsUrl } from 'mk2/apps/strollers/urls';
import { Dot } from 'mk2/components/Dot';
import { Interpolate } from 'mk2/components/Interpolate';
import { Link } from 'mk2/components/Link';
import { StarsRating } from 'mk2/components/StarsRating';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './StrollerDetailRating.mscss';


interface OwnProps {
    stroller: StrollerEntity;
    reviews: StrollerUserReviewEntity[];  // schvalene recenzie kocika 'stroller' alebo jeho pribuznych modelov
}

export const StrollerDetailRating: React.FunctionComponent<OwnProps> = ({
    stroller, reviews,
}) => {
    const { userScore } = stroller;
    const photosCount = reviews.reduce((ret, review) => ret + review.photos.length, 0);

    // Sklonovanie s/so(SK server) a s/se(CZ server), nie je mozne riesit pomocou translation
    const prefix = ([16, 17].includes(photosCount) || ['4', '6', '7'].includes(String(photosCount).charAt(0))
        || (String(photosCount).length === 3 && String(photosCount).charAt(0) === '1')) ? (ACTIVE_SERVER_ID === 201 ? 'so' : 'se') : 's';

    return (
        <Link
            className={styles.StrollerDetailRating}
            to={reviews.length > 0
                    ? url(strollersReviewsUrl, { slug: stroller.slug })
                    : url(strollersAddReviewUrl, { slug: stroller.slug })}
        >
            <StarsRating starsCount={userScore} canShowHalf />
            <Dot
                className={styles.StrollerDetailRating__muted}
                spaces={1}
            />
            {reviews.length > 0 ? (
                <>
                    <Interpolate
                        i18nKey={counter_RATINGS}
                        counter={reviews.length}
                        count={reviews.length}
                    />
                    {photosCount > 0 && (
                        <>
                            <span className={styles.StrollerDetailRating__muted}>
                                &nbsp;{prefix}&nbsp;
                            </span>
                            <Interpolate
                                className={styles.StrollerDetailRating__muted}
                                i18nKey={counter_RATINGS_PHOTOS}
                                counter={photosCount}
                                count={photosCount}
                            />
                        </>
                    )}
                </>
            ) : (
                <>
                    <Interpolate
                        className={styles.StrollerDetailRating__muted}
                        i18nKey={counter_RATINGS}
                        counter={reviews.length}
                        count={reviews.length}
                    />
                    <Dot
                        className={styles.StrollerDetailRating__muted}
                        spaces={1}
                    />
                    {STROLLER_ADD_REVIEW}
                </>
            )}
        </Link>
    );
};

StrollerDetailRating.displayName = 'StrollerDetailRating';
